var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTzLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 412,
    viewBox: "0 0 403 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 180.817L0 59.2319L100.893 0.437256L202.355 59.2319L307.238 0.437256L403 59.2319L201.5 180.817Z",
    fill: "#B327FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.499 180.247V412L301.393 354.918V236.758L402.428 180.247V58.6616L201.499 180.247Z",
    fill: "#FA5AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.499 180.247V412L101.605 354.918V236.758L0.569855 180.247V58.6616L201.499 180.247Z",
    fill: "#681695"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTzLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TZLogo.2ccb9ebb691d613adffad19cf9a660f0.svg";